// This is a simplified version of the translations.
// In a real application, you would have all your translations here.
export default {
    ra: {
        boolean: {
            true: 'Tak',
            false: 'Nie',
        },
        auth: {
            logout: 'Wyloguj się',
            username: 'Nazwa użytkownika',
            password: 'Hasło',
            sign_in: 'Zaloguj się',
            sign_in_error: 'Nieprawidłowa nazwa użytkownika lub hasło',
            remember_me: 'Zapamiętaj mnie',
        },
        action: {
            show: 'Pokaż',
            list: 'Lista',
            edit: 'Edytuj',
            create: 'Utwórz',
            delete: 'Usuń',
            save: 'Zapisz',
            cancel: 'Anuluj',
            export: 'Eksportuj',
            search: 'Szukaj',
            add_filter: 'Dodaj filtr',
            confirm: 'Potwierdź',
            sort: 'Sortuj',
            unselect: 'Odznacz',
            clear_input_value: 'Wyczyść',
            filter: 'Filtruj',
            undo: 'Cofnij',
        },
        message: {
            about: 'O',
            are_you_sure: 'Czy jesteś pewien?',
            bulk_delete_title: 'Usuń %{name} |||| Usuń %{smart_count} wybranych %{name}',
            bulk_delete_content: 'Czy na pewno chcesz usunąć %{name}? |||| Czy na pewno chcesz usunąć %{smart_count} wybranych %{name}?',
            delete_title: 'Usuń %{name} #%{id}',
            delete_content: 'Czy na pewno chcesz usunąć ten element?',
            error: 'Wystąpił błąd i nie można zakończyć żądania',
            invalid_form: 'Formularz jest nieprawidłowy. Sprawdź błędy',
            loading: 'Ładowanie strony, proszę czekać',
            no: 'Nie',
            not_found: 'Nieprawidłowy URL lub nieprawidłowe odwołanie do zasobu',
            yes: 'Tak',
            unsaved_changes: 'Niektóre zmiany nie zostały zapisane. Czy na pewno chcesz je porzucić?',
        },
        navigation: {
            no_results: 'Nie znaleziono wyników',
            no_more_results: 'Strona %{page} jest poza zakresem. Spróbuj poprzednią',
            page_out_of_boundaries: 'Strona %{page} jest poza granicami',
            page_out_from_end: 'Nie można przejść dalej niż ostatnia strona',
            page_out_from_begin: 'Strona nie może być mniejsza niż 1',
            page_range_info: '%{offsetBegin}-%{offsetEnd} z %{total}',
            page_rows_per_page: 'Wierszy na stronę:',
            next: 'Następna',
            prev: 'Poprzednia',
        },
        notification: {
            updated: 'Zaktualizowano',
            created: 'Utworzono',
            deleted: 'Usunięto',
        },
        page: {
            list: 'Lista %{name}',
            show: 'Podgląd %{name}',
            create: 'Utwórz %{name}',
            edit: 'Edytuj %{name} %{id}',
        },
        sort: {
            ASC: 'rosnąco',
            DESC: 'malejąco',
        },
        configurable: {
            customize: 'Dostosuj',
        },
    },
    resources: {
        tenders: {
            name: 'Przetargi',
            archived: 'Archiwalne przetargi',
            failed: 'Przetargi z błędami',
            processed: 'Przetargi przetworzone',
            actions: {
                archive: 'Archiwizuj',
                unarchive: 'Przywróć z archiwum'
            },
            confirm: {
                archive: {
                    title: 'Archiwizacja przetargu',
                    content: 'Czy na pewno chcesz zarchiwizować ten przetarg?'
                },
                unarchive: {
                    title: 'Przywracanie przetargu',
                    content: 'Czy na pewno chcesz przywrócić ten przetarg z archiwum?'
                }
            },
            notifications: {
                archived: 'Przetarg został zarchiwizowany',
                unarchived: 'Przetarg został przywrócony z archiwum',
                error: 'Wystąpił błąd podczas wykonywania operacji'
            },
            fields: {
                id: 'ID',
                source: 'Źródło',
                external_id: 'ID zewnętrzne',
                external_reference: 'Referencja zewnętrzna',
                bzp_number: 'Numer BZP',
                notice_number: 'Numer ogłoszenia',
                title: 'Tytuł',
                cpv_code: 'Kod CPV',
                procedure_result: 'Wynik procedury',
                publication_date: 'Data publikacji',
                publication_date_from: 'Data publikacji od',
                publication_date_to: 'Data publikacji do',
                published_at: 'Opublikowano',
                created_at: 'Utworzono',
                updated_at: 'Zaktualizowano',
                notice_type: 'Rodzaj ogłoszenia',
                client_type: 'Typ klienta',
                order_type: 'Rodzaj zamówienia',
                tender_type: 'Typ przetargu',
                is_tender_amount_below_eu: 'Poniżej progu UE',
                order_object: 'Przedmiot zamówienia',
                submitting_offers_date: 'Data składania ofert',
                organization_name: 'Nazwa organizacji',
                organization_city: 'Miasto organizacji',
                organization_province: 'Województwo organizacji',
                organization_country: 'Kraj organizacji',
                organization_national_id: 'NIP organizacji',
                organization_id: 'ID organizacji',
                update_preview: 'Podgląd aktualizacji',
                bidder_name: 'Nazwa oferenta',
                tender_notice_number: 'Numer ogłoszenia',
                is_winner: 'Zwycięzca',
                offer_value: 'Wartość oferty',
                offer_date: 'Data oferty',
                is_nwu: 'Czy jest NWU',
                is_wadium: 'Czy jest Wadium',
                submission_date: 'Data składania ofert',
                submission_date_from: 'Data składania ofert od',
                submission_date_to: 'Data składania ofert do',
                tender_amount: 'Wartość zamówienia',
                procedure_type: 'Procedura',
                buyer_type: 'Rodzaj zamawiającego',
                buyer_province: 'Województwo zamawiającego',
                buyer_city: 'Miasto zamawiającego',
                buyer_commune: 'Powiat zamawiającego',
                status: 'Status',
                is_archived: 'Zarchiwizowany',
                bid_bond: 'Wadium',
                nwu: 'NWU',
                tender_amount: 'Wartość zamówienia',
                tender_url: 'URL postępowania',
                prediction_rank: 'Pozycja w rankingu',
                company_name: 'Nazwa firmy',
                probability: 'Prawdopodobieństwo',
                score: 'Score',
                pkd_code: 'Kod PKD',
            },
            sections: {
                basic_info: 'Informacje podstawowe',
                contact_info: 'Dane kontaktowe',
                system_info: 'Informacje systemowe',
                buyer_info: 'Dane zamawiającego',
            },
            tabs: {
                basic_info: 'Podstawowe informacje',
                preview: 'Podgląd przetargu',
                updates: 'Aktualizacje',
                bidders: 'Oferenci',
                workflow: 'Przebieg procesu',
                predictions: 'Predykcje',
            },
            export: {
                excel: 'Export do Excel',
                exporting: 'Eksportowanie...',
                success: 'Wyeksportowano %{count} przetargów',
                no_data: 'Brak danych do eksportu',
                error: 'Błąd podczas eksportu',
            },
            errors: {
                predictions_load: 'Błąd ładowania predykcji',
                no_bidder_id: 'Brak ID oferenta w rekordzie',
            },
            no_predictions: 'Brak predykcji dla tego przetargu',
            actions: {
                preview: 'Podgląd',
                open_in_new: 'Otwórz w nowym oknie',
            },
        },
        users: {
            name: 'Użytkownicy',
        },
        myAccount: {
            name: 'Moje konto',
        },
        changePassword: {
            name: 'Zmiana hasła',
            fields: {
                current_password: 'Aktualne hasło',
                new_password: 'Nowe hasło',
                confirm_password: 'Potwierdź nowe hasło',
            },
        },
        editDetails: {
            name: 'Edytuj dane',
            fields: {
                first_name: 'Imię',
                last_name: 'Nazwisko',
                email: 'Email',
            },
        },
        book: {
            name: 'Książka',
        },
        buyers: {
            name: 'Zamawiający',
            fields: {
                id: 'ID',
                name: 'Nazwa',
                external_id: 'ID zewnętrzne',
                party_type: 'Typ podmiotu',
                business_activity: 'Działalność gospodarcza',
                source: 'Źródło',
                email: 'Email',
                website: 'Strona internetowa',
                street: 'Ulica',
                city: 'Miasto',
                municipality: 'Gmina',
                postal_code: 'Kod pocztowy',
                province: 'Województwo',
                country: 'Kraj',
                nuts3_code: 'Kod NUTS3',
                created_at: 'Data utworzenia',
                updated_at: 'Data aktualizacji',
                tax_number: 'NIP',
                registration_number: 'REGON',
                province_code: 'Kod województwa',
                municipality: 'Gmina',
                total_tenders: 'Liczba przetargów',
                active_tenders: 'Aktywne przetargi',
            },
      tabs: {
        basic_info: 'Podstawowe informacje',
        tenders: 'Przetargi',
        predictions: 'Predykcje',
      },
      actions: {
        predict: {
          label: 'Prognozuj zamówienia',
          success:
            'Prognoza zamówień została wygenerowana dla %{name} (%{count} prognoz)',
          error: {
            no_id: 'Brak ID zamawiającego',
            failed: 'Nie udało się wygenerować prognozy',
            message: 'Błąd podczas generowania prognozy: %{error}',
          },
        },
      },
      predictions: {
        no_data:
          'Kliknij "Prognozuj zamówienia" aby wygenerować prognozę zamówień okresowych.',
        metadata: {
          title: 'Informacje o prognozie',
          generated_at: 'Wygenerowano',
          source: 'Źródło',
          analysis_period: 'Okres analizy',
          total_predictions: 'Liczba prognoz',
        },
        orders: {
          title: 'Prognozowane zamówienia okresowe',
        },
        next_expected: 'Następne oczekiwane',
        publication_period: 'Okres publikacji',
        submission_period: 'Okres składania ofert',
        historical_data: 'Dane historyczne',
        occurrences: 'wystąpień',
        occurrences_label: 'Liczba wystąpień w historii',
        confidence: {
          label: 'Prawdopodobieństwo',
          high: 'Wysokie',
          medium: 'Średnie',
          low: 'Niskie',
        },
        category: {
          label: 'Kategoria',
          annual: 'Roczne',
          seasonal: 'Sezonowe',
          periodic: 'Okresowe',
        },
        frequency: {
          label: 'Częstotliwość',
          yearly: 'Rocznie',
          seasonal: 'Sezonowo',
          irregular: 'Nieregularnie',
        },
        historical: {
          year: 'Rok',
          publication_date: 'Data publikacji',
          submission_date: 'Termin składania',
          order_number: 'Nr zamówienia',
        },
      },
      sections: {
        basic_info: 'Informacje podstawowe',
        contact_info: 'Dane kontaktowe',
        company_info: 'Informacje o firmie',
        stats: 'Statystyki',
        system_info: 'Informacje systemowe',
      },
    },
        notifications: {
            name: 'Powiadomienia',
            fields: {
                id: 'ID',
                notification_type: 'Typ powiadomienia',
                notification_type_display: 'Typ',
                reference_date: 'Data odniesienia',
                content: 'Treść',
                created_at: 'Data utworzenia',
                updated_at: 'Data aktualizacji',
            },
        },
        emailTemplates: {
            name: 'Szablony Email',
            fields: {
                name: 'Nazwa',
                subject: 'Temat',
                body: 'Treść',
                description: 'Opis',
                created_at: 'Data utworzenia',
                updated_at: 'Data aktualizacji',
            },
        },
        bidders: {
            name: 'Oferenci',
            all: 'Wszyscy oferenci',
            archived: 'Archiwalni oferenci',
            blocked: 'Zablokowani oferenci',
            deleted: 'Usunięci oferenci',
            failed: 'Oferenci z błędami',
            successful: 'Oferenci zwycięzcy',
            marketing_consent: 'Oferenci z sukcesem',
            leady: 'Oferenci Leady',
            leads: 'Oferenci Leady',
            actions: {
                block: 'Zablokuj',
                unblock: 'Odblokuj',
                block_confirm: 'Blokowanie oferenta',
                unblock_confirm: 'Odblokowanie oferenta',
                block_message: 'Czy na pewno chcesz zablokować oferenta',
                unblock_message: 'Czy na pewno chcesz odblokować oferenta',
                delete: 'Usuń',
                delete_confirm: 'Usuwanie oferenta',
                delete_message: 'Czy na pewno chcesz usunąć oferenta',
            },
            fields: {
                id: 'ID',
                name: 'Nazwa',
                external_id: 'ID zewnętrzne',
                source: 'Źródło',
                status: 'Status',
                status_active: 'Aktywny',
                status_blocked: 'Zablokowany',
                status_deleted: 'Usunięty',
                tax_number: 'NIP',
                registration_number: 'REGON',
                krs: 'KRS',
                pkd: 'PKD',
                province_code: 'Kod województwa',
                street: 'Ulica',
                city: 'Miasto',
                municipality: 'Gmina',
                postal_code: 'Kod pocztowy',
                province: 'Województwo',
                country: 'Kraj',
                nuts3_code: 'Kod NUTS3',
                email: 'Email',
                phone: 'Telefon',
                website: 'Strona internetowa',
                company_type: 'Typ firmy',
                company_type_name: 'Nazwa typu firmy',
                business_activity: 'Działalność gospodarcza',
                notes: 'Notatka',
                type: 'Potencjał',
                type_niski: 'Niski',
                type_średni: 'Średni',
                type_wysoki: 'Wysoki',
                is_current_customer: 'Czy klient Polfund',
                business_start_date: 'Data rozpoczęcia działalności',
                business_end_date: 'Data zakończenia działalności',
                business_suspension_date: 'Data zawieszenia działalności',
                business_resumption_date: 'Data wznowienia działalności',
                total_wins: 'Liczba wygranych',
                total_value: 'Łączna wartość',
                total_offers: 'Złożonych ofert',
                active_offers: 'Aktywnych ofert',
                created_at: 'Data utworzenia',
                updated_at: 'Data aktualizacji',
                last_email_sent: 'Ostatnia wiadomość email',
            },
            tabs: {
                basic_info: 'Podstawowe informacje',
                pwg_details: 'Szczegóły PWG',
                checks: 'Weryfikacje',
                tenders: 'Przetargi',
                emails: 'Wiadomości Email',
                marketing_consent: 'Zgoda marketingowa',
            },
            consents: {
                email: 'Zgoda marketingowa - Email',
                phone: 'Zgoda marketingowa - Telefon',
                group_company: 'Zgoda na firmy z grupy kapitałowej',
            },
            sections: {
                basic_info: 'Informacje podstawowe',
                address: 'Adres i kontakt',
                company_info: 'Informacje o firmie',
                stats: 'Statystyki',
                marketing_consents: 'Zgody marketingowe',
            },
            customer_status: {
                is_customer: 'Uwaga: Ten oferent jest już klientem Polfund',
                not_customer: '',
            },
            export: {
                excel: 'Export do Excel',
                exporting: 'Eksportowanie...',
                success: 'Wyeksportowano %{count} oferentów',
                no_data: 'Brak danych do eksportu',
                error: 'Błąd podczas eksportu',
            },
        },
        email: {
            messages: {
                name: 'Wiadomości Email',
                fields: {
                    id: 'ID',
                    subject: 'Temat',
                    body: 'Treść',
                    to_email: 'Do',
                    cc: 'CC',
                    bcc: 'BCC',
                    status: 'Status',
                    source: 'Źródło',
                    created_by_username: 'Utworzył',
                    created_at: 'Data utworzenia',
                    sent_at: 'Data wysłania',
                    error_message: 'Komunikat błędu',
                    bidder: 'Oferent',
                },
                tabs: {
                    details: 'Szczegóły',
                    body: 'Treść wiadomości',
                },
            },
        },
        workflow: {
            failed_bidder_workflows: 'Nieudane workflow oferentów',
            bidders_with_error: 'Oferenci z błędami',
        },
        dashboard: {
            name: 'Statystyki',
            latest_date: 'Dane z dnia',
            select_date: 'Wybierz datę',
            load_error: 'Nie udało się wczytać najnowszych statystyk. Pokazujemy wartości domyślne.',
            sections: {
                oferenci: {
                    title: 'Oferenci',
                    successful: 'Oferenci zwycięzcy',
                    leady: 'Oferenci leady',
                    errors: 'Oferenci z błędami',
                    marketing_consents: 'Pozyskane nowe zgody',
                    marketing_consents_total: 'Zgody uzyskane przez ostatnie 24h',
                    validation_errors: 'Oferenci z błędem',
                    archive: 'Archiwalni oferenci',
                    status_leads: {
                        title: 'Statusy leadów',
                        error: 'Z błędem',
                        archived: 'Zarchiwizowani',
                        success: 'Z sukcesem',
                        karencja: 'W karencji',
                    },
                },
                zamowienia: {
                    title: 'Przetargi',
                    downloaded: 'Pobrane zamówienia',
                    errors: 'Przetargi z błędami',
                    archived: 'Archiwizacja',
                },
                predykcja: {
                    title: 'Predykcje',
                    new_tenders: 'Nowe: Zamówienia',
                    new_bidders: 'Nowe: Oferenci',
                },
                kpis: {
                    new_leads: 'Nowi leady',
                    processed_tenders: 'Przetargi przetworzone',
                    predictions: 'Nowe predykcje',
                },
                stats: 'Statystyki',
                labels: {
                    wadia: 'Wadia',
                    nwu: 'NWU',
                    suma: 'SUMA',
                    ogolnie: 'Ogólnie',
                    wszyscy: 'Wszyscy',
                },
            },
            heading: 'Statystyki',
        },
        predictions: {
            name: 'Predykcje',
            orders: 'Zamówienia',
        },
    },
    myapp: {
        custom: {
            message: 'Witaj w mojej aplikacji',
        },
    },
};
